export const LANG_VAR_LOCAL_STORAGE_KEY = 'profeed_lang'

export const COLORS = {
  ORANGE: '#ff7200',
  RED: '#ff392a',
  GREEN: '#1da643',
  GREY: '#ddd'
}

export const ADMIN_SIDEBAR = [
  {
    id: 1,
    title: 'sidebar.company_settings',
    icon: 'icon-comp-settings',
    path: null,
    submenu: [
      { id: 11, title: 'sidebar.users', path: 'users', icon: 'icon-profile-users' },
      { id: 12, title: 'sidebar.group_access', path: 'groups', icon: 'icon-profile-keys' },
      { id: 13, title: 'sidebar.animal_types', path: 'animal-types', icon: 'icon-profile-cow' },
      { id: 14, title: 'sidebar.ingredient_types', path: 'ingredient-types', icon: 'icon-profile-ingridients' }
    ]
  },
  {
    id: 2,
    title: 'sidebar.farm_settings',
    icon: 'icon-farm-settings',
    path: null,
    submenu: [
      { id: 21, title: 'sidebar.mixers', path: 'mixers', icon: 'icon-profile-mixers' },
      { id: 23, title: 'base.blanks', path: 'blanks', icon: 'icon-profile-blank' },
      { id: 22, title: 'sidebar.color_indication', path: 'color-indication', icon: 'icon-colorsindicator' }
    ]
  },
  { id: 3, title: 'База міксерів', path: 'mixer-db', icon: 'icon-mixer-db' }
]

export const EMPLOYEE_SIDEBAR = [
  {
    id: 2,
    title: 'sidebar.farm_settings',
    icon: 'icon-farm',
    path: null,
    submenu: [
      { id: 21, title: 'sidebar.mixers', path: 'mixers', icon: 'icon-profile-mixers' },
      { id: 22, title: 'sidebar.color_indication', path: 'color-indication', icon: 'icon-colorsindicator' }
    ]
  }
]
